<script>
import {getOneWhatDoFromDbase, updateOneWhatDo, deleteOneWhatDo} from '@/services/WhatDoServices';
export default {
  props: [ 'wheelId' ],
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      //
      whatDoFromDbase: null,
      //
      editTitle: '',
      editDescription: '',
      editProjects: [],
      weightOptions: [
        { display: 'Low Priority', value: 1},
        { display: 'Normal', value: 2},
        { display: 'High Priority', value: 3},
      ],
      // 
      newProjectTitle: '',
      newProjectTagline: '',
      newProjectWeight: 2,
    };
  },
  computed: {
    trimmedProjects() {
      let projects = [];
      for (let i = 0; i < this.editProjects.length; i++) {
        const p = this.editProjects[i];
        const t = {
          title: p.title.trim(),
          tagline: p.tagline.trim(),
          weight: p.weight,
        };
        projects.push(t);
      }
      return projects;
    },
    canAddNewProject() {
      return this.newProjectTitle.trim().length > 0 && this.newProjectTagline.trim().length > 0;
    },
  },
  methods: {
    revertChanges() {
      console.log('*** starting revertChanges() ***');
      this.editTitle = this.whatDoFromDbase.title;
      this.editDescription = this.whatDoFromDbase.description;
      this.editProjects = [ ...this.whatDoFromDbase.projects ];
    },
    async deleteThisWhatDo() {
      console.log('*** starting deleteThisWhatDo() ***', this.wheelId);
      await deleteOneWhatDo(this.uId, this.token, this.wheelId);

      this.$nextTick(() => {
        this.$router.push('/whatdo');
      });
    },
    removeProject(i) {
      console.log('*** removing project ***', i);
      this.editProjects.splice(i, 1);
    },
    addProjectToWhatDo() {
      console.log('*** starting addProjectToWhatDo() ***');

      // LOCAL ONLY: add project to whatDo wheel
      this.editProjects.push({
        title: this.newProjectTitle.trim(),
        tagline: this.newProjectTagline.trim(),
        weight: this.newProjectWeight,
      });

      // reset newProject inputs
      this.newProjectTitle = '';
      this.newProjectTagline = '';
      this.newProjectWeight = 2;

      const newp = document.querySelector('.add-new-project-to-whatdo-accordion-title');
      if (newp) {
        newp.click();
      }

    },
    // 
    async saveChanges() {
      const updatedWhatDo = {
        title: this.editTitle.trim(),
        description: this.editDescription.trim(),
        projects: [ ...this.trimmedProjects ],
      };
      console.log('*** starting saveChanges() ***', this.wheelId, updatedWhatDo);

      const successfullyUpdatedWhatDo = await updateOneWhatDo(this.uId, this.token, this.wheelId, updatedWhatDo);
      if (successfullyUpdatedWhatDo) {
        // console.log('*** successfullyUpdatedWhatDo ***', successfullyUpdatedWhatDo);
        window.scrollTo(0, 0);
        this.$router.push('/whatdo');
      }
    },
  },
  async created() {
    const w = await getOneWhatDoFromDbase(this.uId, this.token, this.wheelId);
    if (w) {
      console.log('*** got one whatDo from dbase ***', w);
      this.whatDoFromDbase = w;
      
      this.editTitle = w.title;
      this.editDescription = w.description;
      this.editProjects = [ ...w.projects ];
    }
  },
}
</script>

<template>
<div id="page-what-do-one" class="px-4">

  <div id="header" class="py-4">
    <h1>Edit a whatDo wheel</h1>
  </div>

  <div class="mt-2 mb-16">
    <router-link to="/whatdo">
      <v-btn color="purple-darken-1"
             density="comfortable"
             variant="outlined"
             class="px-2 text-body-2"
      >Go Back to all whatDo wheels</v-btn>
    </router-link>
  </div>

  <div v-if="whatDoFromDbase">


    <!-- REVERT OR SAVE -->
    <div class="d-flex justify-space-between align-center">
      <v-btn @click="revertChanges"
             color="grey"
             density="compact"
             variant="outlined"
             class="px-1 text-capitalize"
      >Revert Changes</v-btn>
      <v-btn @click="saveChanges"
             color="green-lighten-1"
             class="px-2"
      >Save Changes</v-btn>
    </div>
    <p class="mt-2 text-grey-darken-2 text-right text-body-2 font-italic">you must click "Save"<br /> to apply these changes</p>



    <!-- WHATDO WHEEL METADATA -->
    <h3 class="mt-10 mb-4 text-center text-capitalize">whatDo Wheel</h3>
    <div id="edit-metadata" class="mb-8 pt-6 pb-2 px-4 bg-blue-lighten-4">
      <v-text-field v-model="editTitle"
                    label="Wheel Title"
                    placeholder="Edit the name of this whatDo wheel"
                    variant="outlined"
                    clearable
      ></v-text-field>

      <v-textarea v-model="editDescription"
                  label="Wheel Description"
                  placeholder="Edit a short description of what this whatDo wheel is for"
                  variant="outlined"
                  rows="2"
                  auto-grow
                  clearable
      ></v-textarea>
    </div>


    <!-- WHATDO PROJECTS -->
    <div class="mt-16 mb-8">
      <h3 class="mb-4 text-center text-capitalize"><b><u>{{ editProjects.length }} Projects</u></b></h3>

      <div v-if="editProjects.length" class="my-2">
        <div v-for="(proj, i) in editProjects" :key="i" class="bg-orange-lighten-4 border mb-12 pt-6 pa-4">
          <v-text-field v-model="editProjects[i].title"
                        label="Project Title"
                        placeholder="Edit the project title"
                        variant="outlined"
                        clearable
          ></v-text-field>
          <v-textarea v-model="editProjects[i].tagline"
                      label="Project Tagline"
                      placeholder="Edit brief description of this project"
                      variant="outlined"
                      rows="2"
                      auto-grow
                      clearable
          ></v-textarea>
          <v-select v-model="editProjects[i].weight"
                    :items="weightOptions"
                    item-title="display"
                    item-value="value"
                    label="Weight/Importance"
                    variant="outlined"
          ></v-select>

          <v-btn @click="removeProject(i)"
                 color="red-lighten-1"
                 density="compact"
                 variant="outlined"
                 class="text-lowercase font-italic"
          >Remove this project</v-btn>
        </div>
      </div>

    </div> <!-- end WHATDO PROJECTS -->


    <!-- ADD PROJECT TO WHATDO -->
    <v-expansion-panels class="mt-8 mb-12">
      <v-expansion-panel>
        <v-expansion-panel-title class="add-new-project-to-whatdo-accordion-title bg-blue-lighten-2 text-white font-weight-black">Add another project to this whatDo wheel</v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="py-4">
            <v-text-field v-model="newProjectTitle"
                          label="Project Title"
                          placeholder="Edit the project title"
                          variant="outlined"
                          clearable
            ></v-text-field>
            <v-textarea v-model="newProjectTagline"
                        label="Project Tagline"
                        placeholder="Edit brief description of this project"
                        variant="outlined"
                        rows="2"
                        auto-grow
                        clearable
            ></v-textarea>
            <v-select v-model="newProjectWeight"
                      :items="weightOptions"
                      item-title="display"
                      item-value="value"
                      label="Weight/Importance"
                      variant="outlined"
            ></v-select>

            <div class="d-flex justify-end">
              <v-btn @click="addProjectToWhatDo()"
                     :disabled="!canAddNewProject"
                     :color="canAddNewProject ? 'blue-lighten-1' : 'grey'"
                     density="compact"
                     class="text-lowercase font-italic"
              >Add this project</v-btn>
            </div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>


    <!-- REVERT OR SAVE -->
    <div class="d-flex justify-space-between align-center">
      <v-btn @click="revertChanges"
             color="grey"
             density="compact"
             variant="outlined"
             class="px-1 text-capitalize"
      >Revert Changes</v-btn>
      <v-btn @click="saveChanges"
             color="green-lighten-1"
             class="px-2"
      >Save Changes</v-btn>
    </div>
    <p class="mt-2 text-grey-darken-2 text-right text-body-2 font-italic">you must click "Save"<br /> to apply these changes</p>

    <!-- DELETE -->
    <v-btn @click.prevent="deleteThisWhatDo"
           color="red-lighten-1"
           density="comfortable"
           variant="outlined"
           class="mt-8 mb-8 px-2 font-italic text-body-2"
    >Delete this whatDo wheel</v-btn>

    <div class="mb-16">
      <router-link to="/whatdo">
        <v-btn color="purple-darken-1"
               density="comfortable"
               variant="outlined"
               class="px-2 text-body-2"
        >Go Back to all whatDo wheels</v-btn>
      </router-link>
    </div>


  </div> <!-- end if-what-do -->


</div>
</template>

<style scoped lang="scss">
#page-what-do-one {
  max-width: 700px;
  margin: 0 auto;


}
</style>
